<template>
    <v-layout row wrap>
        <v-flex>
            <v-form ref="materialCreationForm" v-model="isValid">
                <v-select
                        :items="materialTypeOptions"
                        v-model="type"
                        :label="$t('materials.creationForm.fields.type.label')"
                        item-value="value"
                        item-text="title"
                        :rules="typeRules"
                        required
                ></v-select>
                <v-text-field
                        v-model="code"
                        :label="$t('materials.creationForm.fields.code.label')"
                        :rules="codeRules"
                        :hint="$t('materials.creationForm.fields.code.hint')"
                        :error-messages="codeErrorMessages"
                        persistent-hint
                        counter="100"
                        maxlength="100"
                        @input="codeFieldInputHandler"
                        requiredmaterials.creationForm.fields.code
                >
                    <v-tooltip slot="append" bottom max-width="500">
                        <v-icon slot="activator" color="primary" class="fas fa-question-circle question"></v-icon>
                        <span v-html="$t('materials.creationForm.fields.code.tooltip')"></span>
                    </v-tooltip>
                </v-text-field>
                <v-text-field
                        v-if="type === 'tissues'"
                        v-model="fragments"
                        :label="$t('materials.creationForm.fields.fragments.label')"
                        :rules="fragmentsRules"
                        type="number"
                        min="1"
                        step="1"
                        required
                ></v-text-field>
                <v-text-field
                        v-model="description"
                        :label="$t('materials.creationForm.fields.description.label')"
                        :rules="descriptionRules"
                        counter="200"
                        maxlength="200"
                ></v-text-field>
                <v-btn
                    :disabled="!isValid"
                    :loading="creationInProgress"
                    @click="handleCreateButtonClick"
                    v-t="'materials.creationForm.buttons.create.label'"
                >
                </v-btn>
                <v-btn @click="handleCancelButtonClick" v-t="'materials.creationForm.buttons.cancel.label'">Cancel</v-btn>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>

  import {AvailableMaterialTypes} from '../../dictionaries/case-materials'
  import {validateStringLength} from '../../helpers/validation'
  import {getStringOrNull} from '../../helpers/strings'
  import _ from 'lodash'

  export default {
    name: "material-creation-form",
    props: {
      readOnly: {
        Type: Boolean
      },
      value: {
        Type: Object
      },
      checkMaterialExistsFunc: {
        Type: Function
      }
    },
    data () {
      return {
        creationInProgress: false,
        code: _.get(this.value, 'code', null),
        codeErrorMessages: [],
        description: _.get(this.value, 'description', null),
        fragments: _.get(this.value, 'fragments', null),
        type: _.get(this.value, 'type', null),
        isValid: null,
        typeRules: [
          v => !!v || this.$t('materials.creationForm.fields.type.errors.required'),
        ],
        codeRules: [
          v => !!v || this.$t('materials.creationForm.fields.code.errors.required'),
          v => (v && v.length <= 100) || this.$t('materials.creationForm.fields.code.errors.length')
        ],
        fragmentsRules: [
          v => (this.type !== 'tissues') || !!v || this.$t('materials.creationForm.fields.fragments.errors.required'),
          v => (this.type !== 'tissues') || /^\d+$/.test(String(v)) || this.$t('materials.creationForm.fields.fragments.errors.number'),
          v => (this.type !== 'tissues') || Number(v) >= 1 || this.$t('materials.creationForm.fields.fragments.errors.min')
        ],
        descriptionRules: [
          _.partial(validateStringLength, _, 200, this.$t('materials.creationForm.fields.description.errors.length'))
        ],
      }
    },
    watch: {
      value: function() {
        if (this.value !== null && !this.readOnly) {
          this.code = _.get(this.value, 'code', this.code)
        }
      },
      type: function (newType) {
        if (newType !== 'tissues') {
          this.fragments = null
        }
      }
    },
    computed: {
      materialTypeOptions () {
        let result = []
        for (let availableMaterialType of AvailableMaterialTypes) {
          result.push({
            'title': this.$t(availableMaterialType.localizationKeyOne),
            'value': availableMaterialType.value
          })
        }
        return result
      },
    },
    methods: {
      codeFieldInputHandler () {
        if (0 === this.codeErrorMessages.length) {
          return true
        }

        this.codeErrorMessages = []
      },
      async handleCreateButtonClick () {
        this.creationInProgress = true

        let checkExistResult = false

        if (this.code.length > 0) {
          checkExistResult = await this.checkMaterialExistsFunc(this.code)
        }

        if (true === checkExistResult) {
          this.codeErrorMessages.push(this.$t('materials.creationForm.fields.code.errors.exists'))
          this.creationInProgress = false
          return
        }

        this.$emit('create', {
          code: getStringOrNull(this.code),
          description: getStringOrNull(this.description),
          type: this.type,
          ...(this.type === 'tissues' ? { fragments: Number(this.fragments) } : {})
        })
        this.reset()
        this.creationInProgress = false
      },
      handleCancelButtonClick () {
        this.$emit('cancel')
        this.reset()
      },
      reset () {
        this.code = null
        this.description = null
        this.fragments = null
        this.type = null
        this.isValid = null
        this.codeErrorMessages = []
      }
    }
  }
</script>

<style scoped>
    .question {
        cursor: pointer;
    }
</style>